var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinImagenNotificaciones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sin-imagen-notificaciones_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.267,
    width: 67.467,
    height: 44,
    rx: 4,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sin-imagen-notificaciones_svg__a)",
    fill: "#000018"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.29 30.479c1.597-1.809 3.347-4.429 3.347-9.81 0-5.382-2.354-7.804-2.354-7.804l-.783-.933-19.283-22.707a7.538 7.538 0 00-2.323-1.852 7.25 7.25 0 00-5.734-.391 7.44 7.44 0 00-2.537 1.52l-.074.07a7.747 7.747 0 00-1.78 2.412 8.039 8.039 0 00-.364 5.944c.32.966.82 1.858 1.472 2.625l14.31 16.878a6.327 6.327 0 011.578 4.155 5.895 5.895 0 01-.468 2.339 5.713 5.713 0 01-1.35 1.936l-16.67 15.87a7.973 7.973 0 00-1.856 5.637c.126 2.06 1.035 3.983 2.527 5.349l.08.07a7.34 7.34 0 005.433 1.924c1.986-.131 3.84-1.073 5.155-2.62l21.675-20.612z",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.31 30.034c-1.296 1.472-2.716 3.605-2.716 7.984 0 4.38 1.91 6.35 1.91 6.35l.636.76 15.654 18.479a6.122 6.122 0 001.885 1.507 5.873 5.873 0 004.655.318 6.035 6.035 0 002.06-1.237l.06-.057a6.304 6.304 0 001.444-1.963 6.557 6.557 0 00.295-4.837 6.388 6.388 0 00-1.194-2.136L62.382 41.466a5.157 5.157 0 01-1.28-3.38 4.808 4.808 0 01.38-1.904c.254-.6.628-1.137 1.096-1.576L76.11 21.692a6.5 6.5 0 001.506-4.588 6.437 6.437 0 00-2.051-4.353l-.065-.057a5.95 5.95 0 00-4.41-1.565 6.01 6.01 0 00-4.185 2.132L49.31 30.034z",
    fillOpacity: 0.08
  }))));
}
export default __webpack_public_path__ + "static/media/sin-imagen-notificaciones.0fd6c120.svg";
export { SvgSinImagenNotificaciones as ReactComponent };